export default __webpack_public_path__ + "static/media/2.a4a7b1a6.webp";